<template>
  <div class="app-container">
    <!-- 超人圈帖子管理 -->
    <el-tabs v-model="activeIndex" type="border-card" @tab-click="handleClick" v-tab-change:activeIndex="setActiveName">
      <!--标签页：超人圈话题、帖子-->
      <el-tab-pane label="超人圈话题" name="0">
        <!-- 顶部栏搜索 -->
        <el-card class="filter-container" style="margin-top: -15px" shadow="never">
          <el-row  type="flex" justify="end" style="padding-bottom: 20px">
            <el-dropdown split-button type="primary" size="small" @command="handleCommandCreateArticle" @click="openAddUltrasonicDialog()">
              发表话题
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="normalEditor">普通话题</el-dropdown-item>
                <el-dropdown-item command="richEditor">文章</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
              <el-button size="small" type="primary" @click="openEditForumConfigDialog()" style="margin-left: 3px">上传配置</el-button>
          </el-row>
          <el-row>
            <el-col :span="13">
                <el-input
                  v-model="searchValue"
                  size="small"
                  clearable
                  placeholder="关键词：标题 / 描述 / 姓名 / 昵称 / 类型"
                  prefix-icon="el-icon-search"
                  @keyup.native.enter="search()"
                />
            </el-col>
            <el-col :span="1" style="margin-left: 3px">
              <el-button
                  type="primary"
                  icon="el-icon-search"
                  size="small"
                  @click.stop="search()"
              >
              </el-button>
            </el-col>
            <el-col :span="3" style="margin-left: 3px;">
              <el-select
                  v-model="searchForumType1"

                  placeholder="全部文本形式"
                  size="small"
                  clearable
                  @change="search()"
              >
                <el-option label="普通超人圈" :value="0" />
                <el-option label="文章" :value="6" />
                <el-option label="视频" :value="2" />
                <el-option label="链接文章" :value="1" />
              </el-select>
            </el-col>
            <el-col v-if="forumCategoryList.length > 0" :span="3" style="margin-left: 3px;">
                <el-select
                        size="small"
                        v-model="searchForumType"
                        placeholder="全部话题类型"
                        clearable
                        @change="search()"
                >
                  <el-option v-for="item in forumCategoryList" :value="item.forumCategoryId" :key="item.forumCategoryId" :label="item.categoryName"></el-option>
                  </el-select>
            </el-col>
            <el-col :span="3" style="margin-left: 3px;">
              <el-select
                      size="small"
                      v-model="searchPosition"
                      placeholder="所有可见范围"
                      clearable
                      @change="search()"
              >
                <el-option label="广场可见" :value="1" />
                <el-option label="仅圈子内可见" :value="2" />
              </el-select>
            </el-col>
          </el-row>
        </el-card>
        <!-- 表内容 -->
        <el-table
          v-loading="loading"
          highlight-current-row
          :data="allForumsList"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form
                      label-position="left"
                      inline
                      class="demo-table-expand"
              >
                <el-col :span="24" style="margin:20px">
                  <el-form-item label="正文">
                    <span>{{extractFirst100Chars(scope.row.customDescription,200)}}</span>
                  </el-form-item>
                </el-col>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="forumId" label="#" align="center" width="60"/>
          <el-table-column prop="forumType" label="文本形式" align="center" width="90">
            <template slot-scope="scope">
              {{ scope.row.forumType | forumTypeTransform }}
            </template>
          </el-table-column>
          <el-table-column
            prop="customTitle"
            label="标题"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span style="color: darkgreen">{{ scope.row.customTitle}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="forumGroupId" show-overflow-tooltip label="发布圈子(群组)" align="center" width="160">
            <template slot-scope="scope">
              {{ getForumGroupName(scope.row.forumGroupId)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="发布人"
            align="center"
            width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope"> <i v-if="scope.row.isUltraExpert" class="el-icon-star-off"></i> {{ scope.row.nickname }}</template>
          </el-table-column>
          <el-table-column label="发表日期" align="center" width="100">
            <template slot-scope="scope">
              <span>
              {{ scope.row.createTime | formatDate }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center" width="48">
            <template slot-scope="scope">
            {{ getCategoryName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column sortable prop="pageViews" label="浏览" align="center" width="45">
            <template slot-scope="scope">
              {{ scope.row.pageViews }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="commentCount" label="评论" align="center" width="45">
            <template slot-scope="scope">
              {{ scope.row.commentCount }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="commentCount" label="点赞" align="center" width="45">
            <template slot-scope="scope">
              {{ scope.row.likerCount }}
            </template>
          </el-table-column>
          <el-table-column prop="forumType" label="来源" align="center" width="90">
            <template slot-scope="scope">
              {{ scope.row.source | forumSourceTransform }}
            </template>
          </el-table-column>
          <el-table-column label="置顶"  align="center" width="50">
            <template slot-scope="scope"><el-switch v-model="scope.row.isTop" active-color="#03be56" :active-value=true :inactive-value=false  @change="setForums(scope.row, 1)"></el-switch></template>
          </el-table-column>
          <el-table-column label="精华"  align="center" width="50">
            <template slot-scope="scope"><el-switch v-model="scope.row.isEssential" active-color="#03be56" :active-value=true :inactive-value=false  @change="setForums(scope.row, 0)"></el-switch></template>
          </el-table-column>
          <el-table-column label="推荐"  align="center" width="50">
            <template slot-scope="scope"><el-switch v-model="scope.row.isRecommended" active-color="#03be56" :active-value=true :inactive-value=false  @change="setForums(scope.row, 2)"></el-switch></template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.stop="goToUltrasonicDetail(scope.row)"

              >
                编辑
              </el-button>
              <el-button
                size="small"
                :type="scope.row.isDeleted ? 'warning' : 'danger'"
                @click.stop="deleteOrBackForums(scope.row)"
              >
                {{ scope.row.isDeleted ? "恢复" : "删除" }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          v-show="totalCount > 10"
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="currentChange"
        />
        <div style="margin-left: 10px">
        <p style="color: dimgrey;float: left">共{{totalCount}}条</p>
        <el-select v-model="pageSize" placeholder="全部分页" style="width:110px;margin-left: 5px;margin-top:7px" @change="onPageSizeChange">
          <el-option v-for="item in pageSizeOptions" :value="item.fieldValue" :label="item.showName"
                     :key="item.fieldValue" />
        </el-select>
        </div>
      </el-tab-pane>
      <!--标签页：超人圈群组管理-->
      <el-tab-pane :label="$t('route.ultrasonicGroups')" name="2">
        <!-- 顶部栏搜索 -->
        <el-card class="filter-container" style="margin-top: -15px" shadow="never">
          <el-row>
            <el-col :span="13">
            <el-input
              v-model="searchValue"
              size="small"
              clearable
              placeholder="圈子名称 / 简介 / 创建者昵称 / 创建者姓名"
              prefix-icon="el-icon-search"
              class="search-input"
            />
            </el-col>
            <el-col :span="1">
              <el-button
                  type="primary"
                  icon="el-icon-search"
                  size="small"
                  style="margin-left: 5px"
                  @click.stop="search()"
              >
              </el-button>
            </el-col>
            <el-col :span="3">
            <el-select
                v-if="categoryList.length > 0"
                      size="small"
                      style="margin-left: 5px"
                      v-model="userDataType"
                      placeholder="领域"
                      clearable
                      @change="search"
             >
                  <el-option
                          v-for="item in categoryList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                  ></el-option>
             </el-select>
            </el-col>
            <el-col :span="3">
            <el-select
                size="small"
                v-model="groupType"
                style="margin-left: 5px"
                placeholder="是否公开"
                clearable
                @change="search"
            >
              <el-option
                  v-for="item in groupTypeList"
                  :key="item.id"
                  :label="item.showName"
                  :value="item.id"
              ></el-option>
            </el-select>
            </el-col>
            <el-col :span="3">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="margin-left: 5px"
            @click.stop="openAddUltrasonicGroupsDialog()"
          >
            创建圈子/群组
          </el-button>
            </el-col>
          </el-row>
        </el-card>
        <!-- 表内容 -->
        <el-table
          v-loading="loading"
          highlight-current-row
          :data="allForumGroupList"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
        >

          <el-table-column prop="forumGroupId" label="ID" width="90" align="center" />
            <el-table-column
                    label="封面"
                    align="center"
                    show-overflow-tooltip
            >
                <template #default="props">
                    <el-avatar v-if="showDefaultImage(props.row.groupIcon)" :src="imageGroupUrl"></el-avatar>
                    <el-avatar v-if="props.row.groupIcon" :key="props.row.groupIcon" :src="getImageUrl(props.row.groupIcon)"></el-avatar>
                </template>
            </el-table-column>
          <el-table-column
                    prop="groupName"
                    label="圈子名称"
                    align="center"
                    show-overflow-tooltip
          >
              <template slot-scope="scope">
                  <span>{{ scope.row.groupName}}</span>
              </template>
          </el-table-column>
          <el-table-column label="成员" align="center" width="50">
            <template slot-scope="scope">
              <a style="color: blue;font-weight: bold;text-decoration: underline;"  @click.stop="goToUltrasonicGroupsMember(scope.row)">{{ scope.row.memberSum }}</a>
            </template>
          </el-table-column>
          <el-table-column label="话题" align="center" width="50">
            <template slot-scope="scope">
              <a style="color: blue;font-weight: bold;text-decoration: underline;" @click.stop="goToUltrasonicGroupsPost(scope.row)">{{ scope.row.forumSum }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="圈主"
            align="center"
            show-overflow-tooltip
          >
              <template slot-scope="scope">
                  <i v-if="scope.row.isUltraExpert" class="el-icon-star-off"></i>
                  {{ scope.row.nickname}}
              </template></el-table-column>
          <el-table-column prop="groupType" label="是否公开" align="center">
            <template slot-scope="scope">
              {{ scope.row.GroupType ? "私有" : "公开" }}
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.createTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="推荐热门"  align="center" width="60">
            <template slot-scope="scope"><el-switch v-model="scope.row.showType" active-color="#03be56" :active-value=1 :inactive-value=0  @change="setForumGroup(scope.row)"></el-switch></template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.stop="goToUltrasonicGroupsDetail(scope.row)"
              >
                查看
              </el-button>
              <el-button
                size="small"
                :type="scope.row.isDeleted ? 'warning' : 'danger'"
                @click.stop="deleteOrBackForumGroup(scope.row)"
              >
                {{ scope.row.isDeleted ? "恢复" : "删除" }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          v-show="totalCount > pageSize"
          background
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="currentChange"
        />
        <div style="margin-left: 10px">
          <p style="color: dimgrey;float: left" >共{{totalCount}}条</p>
          <el-select v-model="pageSize" placeholder="全部产品分类" style="width:110px;margin-left: 5px;margin-top:7px" @change="onPageSizeChange">
            <el-option v-for="item in pageSizeOptions" :value="item.fieldValue" :label="item.showName"
                       :key="item.fieldValue" />
          </el-select>
        </div>
      </el-tab-pane>
      <!--标签页：帖子类型管理-->
      <el-tab-pane label="话题类型" name="1">
        <!-- 顶部栏 -->
        <div class="topbar">
          <div></div>
          <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click.stop="openAddTypeDialog()"
          >
            新增类型
          </el-button>
        </div>
        <!-- 表内容 -->
        <el-table
            v-loading="loading"
            highlight-current-row
            :data="forumCategoryList"
            :header-cell-style="{ background: '#F5F7FA' }"
            style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column
              prop="forumCategoryId"
              label="#"
              align="center"
              width="150"
          />
          <el-table-column prop="categoryName" label="话题类型" align="center" >
            <template slot-scope="scope">
              <span style="color: darkgreen">{{scope.row.categoryName}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
              width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                  size="small"
                  type="primary"
                  @click.stop="openEditTypeDialog(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                  size="small"
                  :type="scope.row.isDeleted ? 'warning' : 'danger'"
                  @click.stop="deleteOrBackForumCategory(scope.row)"
              >
                {{ scope.row.isDeleted ? "恢复" : "删除" }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!--标签页：群组标签管理-->
      <el-tab-pane label="群组标签" name="3">
        <!-- 顶部栏 -->
        <div class="topbar">
          <div></div>
          <el-button
                  type="primary"
                  icon="el-icon-plus"
                  size="small"
                  @click.stop="openAddTagDialog"
          >
            新增标签
          </el-button>
        </div>
        <el-table
                v-loading="loading"
                highlight-current-row
                :data="forumGroupTagList"
                :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column
                  prop="forumGroupTagId"
                  label="#"
                  align="center"
                  width="150"
                  show-overflow-tooltip
          />
          <el-table-column prop="tagName" label="名称" align="center" >
            <template slot-scope="scope">
              <span style="color: darkgreen">{{scope.row.tagName}}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="默认标签"
                  align="center"
                  width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.isSystemDefault?"是":"否" }}
            </template>
          </el-table-column>
          <el-table-column
              prop="nickname"
              label="创建者"
              align="center"
              width="150"
              show-overflow-tooltip
          />
          <el-table-column
                  prop="createTime"
                  label="创建时间"
                  align="center"
                  width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                      size="small"
                      :type="scope.row.isDeleted ? 'warning' : 'danger'"
                      @click.stop="deleteTags(scope.row)"
              >
                {{ scope.row.isDeleted ? "恢复" : "删除" }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
                v-show="totalCount > pageSize"
                background
                layout="prev, pager, next"
                :total="totalCount"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="currentChange"
        />
      </el-tab-pane>
    </el-tabs>

    <!--发表文章对话框-->
    <el-dialog title="创作文章" :visible.sync="addRichArticleDialog" fullscreen>
      <el-form :model="addUltrasonicForm">
        <el-form-item label="文章标题" label-width="80px"  required>
          <el-input
              placeholder="不少于4个字"
              v-model="addUltrasonicForm.customTitle"
              autocomplete="off"
          />
        </el-form-item>
        <MyEditor ref="myEditor" />
        <div style="margin-top: 10px">
          <el-form-item label="配置"  required label-width="50px" style="margin-bottom: 5px;">
            <el-col :span="6" style="padding: 3px">
              <el-select v-model="addUltrasonicForm.isHideOnSquare"  placeholder="设置公开到广场" style="width: 100%" @change="selectForumGroup()">
                <el-option label="广场可见" :value=false />
                <el-option label="仅圈子内可见" :value=true />
              </el-select>
            </el-col>
            <el-col :span="6" style="padding: 3px">
              <el-select v-model="addUltrasonicForm.forumGroupId"  placeholder="发布到圈子/群组" clearable style="width: 100%" @change="selectForumGroup()">
                <el-option
                    v-for="item of this.allExistForumGroupList"
                    :key="item.forumGroupId"
                    :value="item.forumGroupId"
                    :label="item.groupName"
                >
                  <img style="width:18px;height:25px;padding-top: 7px" :src="(null===item.groupIcon||''===item.groupIcon)?imageGroupUrl:getImageUrl(item.groupIcon)">
                  <span>{{' '+item.groupName}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{' 话题:'+item.forumSum+' 成员:'+item.memberSum+''}}</span>

                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6"  style="padding: 3px">
              <el-select v-model="addUltrasonicForm.categoryId"
                         placeholder="设置帖子类型"
                         clearable
                         style="width: 100%"
                         @change="$forceUpdate()"
              >
                <el-option
                    v-for="item of this.forumCategoryList"
                    :key="item.forumCategoryId"
                    :value="item.forumCategoryId"
                    :label="item.categoryName"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6" style="padding: 3px" v-if="userDataTypeOptions.length > 0">
              <el-select
                  placeholder="设置所属领域"
                  clearable
                  v-model="addUltrasonicForm.userDataType"
                  style="width: 100%"
                  @change="$forceUpdate()"
              >
                <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value" :label="item.name"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="通知" required label-width="50px">
            <el-col :span="6"  style="padding: 3px">
              <el-select v-model="addUltrasonicForm.needNotice"  placeholder="请选择是否通知用户阅读" style="width: 100%" @change="$forceUpdate()">
                <el-option label="不需要通知用户阅读" :value=0 />
                <el-option label="需要通知用户阅读" :value=1 />
              </el-select>
            </el-col>
            <el-col :span="6"  style="padding: 3px" v-if="1===addUltrasonicForm.needNotice" >
              <el-select v-model="addUltrasonicForm.noticeObject"  placeholder="请选择通知对象" style="width: 100%" @change="processChangeNoticeObject()">
                <el-option label="通知指定圈子阅读" :value=1 />
                <el-option label="通知指定用户阅读" :value=0 />
              </el-select>
            </el-col>
            <el-col :span="6"  style="padding: 3px" v-if="1 === addUltrasonicForm.needNotice && 1===addUltrasonicForm.noticeObject">
              <el-select
                  v-model="addUltrasonicForm.idList"
                  multiple
                  :disabled="disableNoticeObject"
                  collapse-tags
                  style="width: 100%"
                  @change="$forceUpdate()"
                  placeholder="请选择通知圈子">
                <el-option
                    v-for="item of this.allExistForumGroupList"
                    :key="item.forumGroupId"
                    :value="item.forumGroupId"
                    :label="item.groupName"
                >
                  <img style="width:18px;height:25px;padding-top: 7px" :src="(null===item.groupIcon||''===item.groupIcon)?imageGroupUrl:getImageUrl(item.groupIcon)">
                  <span>{{' '+item.groupName}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{' 话题:'+item.forumSum+' 成员:'+item.memberSum+''}}</span>
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6"  style="padding: 3px" v-if="1 === addUltrasonicForm.needNotice && 0===addUltrasonicForm.noticeObject">
              <el-select
                  v-model="addUltrasonicForm.idList"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请填写通知用户"
                  style="width: 100%"
                  @change="$forceUpdate()"
                  :remote-method="remoteSearchUserList"
                  :loading="searchUserLoading">
                  <el-option
                      v-for="item in searchUserList"
                      :key="item.userID"
                      :value="item.userID"
                      :label="getUserDetailInfo(item)">
                  </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
<!--        <el-button size="small" type="primary" @click="showInsertNetDiskFileDialog()">插入云盘文件</el-button>-->
        <el-button size="small" type="primary" @click="showInsertCsFileDialog()">插入客服文档</el-button>
        <el-button size="small" type="success" @click="previewArticle()">预览文章</el-button>
        <el-button size="small" @click="addRichArticleDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="addUltrasonic(1)">
          发 布
        </el-button>
      </div>
    </el-dialog>

    <!-- 发表话题对话框 addUltrasonicDialog -->
    <el-dialog title="发表话题" :visible.sync="addUltrasonicDialog" width="45%">
      <el-form :model="addUltrasonicForm" label-width="150px">
        <el-form-item label="标题"  required>
          <el-input
                  placeholder="不少于4个字"
                  v-model="addUltrasonicForm.customTitle"
                  autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="正文" required>
          <el-input
              placeholder="分享点什么（请勿留空白）..."
              v-model="addUltrasonicForm.customDescription"
              type="textarea"
              :rows="5"
          />
        </el-form-item>
        <el-form-item label="广场公开"  required >
          <el-select v-model="addUltrasonicForm.isHideOnSquare"  placeholder="设置公开到广场" style="width: 100%" @change="selectForumGroup()">
            <el-option label="广场可见" :value=false />
            <el-option label="仅圈子内可见" :value=true />
          </el-select>
        </el-form-item>
        <el-form-item label="发布到圈子" >
          <el-select v-model="addUltrasonicForm.forumGroupId" placeholder="选择要发表的圈子" clearable style="width: 100%" @change="selectForumGroup()">
            <el-option
                v-for="item of this.allExistForumGroupList"
                :key="item.forumGroupId"
                :value="item.forumGroupId"
                :label="item.groupName"
            >
              <img style="width:18px;height:25px;padding-top: 7px" :src="(null===item.groupIcon||''===item.groupIcon)?imageGroupUrl:getImageUrl(item.groupIcon)">
              <span>{{' '+item.groupName}}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{' 话题:'+item.forumSum+' 成员:'+item.memberSum+''}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="话题类型" required>
          <el-col :span="12">
            <el-select v-model="addUltrasonicForm.forumType"  placeholder="请选择" style="width: 100%" @change="$forceUpdate()">
              <el-option label="普通超人圈" :value="0" />
              <el-option label="视频" :value="2" />
              <el-option label="链接文章" :value="1" />
            </el-select>
          </el-col>
          <el-col :span="11" style="margin-left: 15px">
            <el-select v-model="addUltrasonicForm.categoryId"
                       placeholder="设置类型"
                       clearable
                       style="width: 100%"
                       @change="$forceUpdate()"
            >
              <el-option
                  v-for="item of this.forumCategoryList"
                  :key="item.forumCategoryId"
                  :value="item.forumCategoryId"
                  :label="item.categoryName"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="userDataTypeOptions.length > 0" label="所属领域" >
          <el-select
            v-model="addUltrasonicForm.userDataType"
            style="width: 100%"
            @change="$forceUpdate()"
          >
            <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addUltrasonicForm.forumType === 1" label="链接" >
          <el-input v-model="addUltrasonicForm.postURL" autocomplete="off" />
        </el-form-item>
        <el-form-item  v-if="addUltrasonicForm.forumType === 2" label="视频类型">
          <el-select v-model="addUltrasonicForm.resourceType" @change="$forceUpdate()" >
            <el-option label="平台视频课程" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="addUltrasonicForm.forumType === 2" label="视频ID">
          <el-input v-model="addUltrasonicForm.resourceID" autocomplete="off" title="视频ID"/>
        </el-form-item>
        <el-form-item label="数据来源"  required>
          <el-radio-group v-model="addUltrasonicForm.source" @change="$forceUpdate()">
            <el-radio :label="0">SIUI分享</el-radio>
            <el-radio :label="1">用户反馈案列</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="通知用户阅读">
          <el-radio-group v-model="addUltrasonicForm.needNotice" @change="$forceUpdate()">
            <el-radio :label="0">不需要</el-radio>
            <el-radio :label="1">需要</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="通知对象"  required v-if="1===addUltrasonicForm.needNotice">
          <el-radio-group v-model="addUltrasonicForm.noticeObject" @change="processChangeNoticeObject()">
            <el-radio :label="1">指定圈子</el-radio>
            <el-radio :label="0">指定用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="通知圈子"  required v-if="1 === addUltrasonicForm.needNotice && 1===addUltrasonicForm.noticeObject">
          <el-select
              v-model="addUltrasonicForm.idList"
              multiple
              :disabled="disableNoticeObject"
              collapse-tags
              style="margin-left: 20px;"
              placeholder="请选择">
            <el-option
                v-for="item of this.allExistForumGroupList"
                :key="item.forumGroupId"
                :value="item.forumGroupId"
                :label="item.groupName"
            >
              <img style="width:18px;height:25px;padding-top: 7px" :src="(null===item.groupIcon||''===item.groupIcon)?imageGroupUrl:getImageUrl(item.groupIcon)">
              <span>{{' '+item.groupName}}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{' 话题:'+item.forumSum+' 成员:'+item.memberSum+''}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知用户"  required v-if="1 === addUltrasonicForm.needNotice && 0===addUltrasonicForm.noticeObject">
          <el-select
              v-model="addUltrasonicForm.idList"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入"
              :remote-method="remoteSearchUserList"
              :loading="searchUserLoading">
              <el-option
                  v-for="item in searchUserList"
                  :key="item.userID"
                  :value="item.userID"
                  :label="getUserDetailInfo(item)">
              </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addUltrasonicDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="addUltrasonic(0)">
          发 布
        </el-button>
      </div>
    </el-dialog>

    <el-drawer
        title="客服文档列表"
        :visible.sync="showCsFileDialog"
        direction="rtl"
        size="50%"
    >
      <el-table :data="csFileList" highlight-selection-row height="450">
        <el-table-column property="fileShowName" align="center" label="文件名" ></el-table-column>
        <el-table-column property="fileSuffix" align="center" label="格式" width="100"></el-table-column>
        <el-table-column property="fileSize" align="center" label="大小（MB）" width="100">
          <template slot-scope="scope">
            {{ (scope.row.fileSize / 1024).toFixed(1) }}
          </template>
        </el-table-column>
        <el-table-column property="nickname" align="center" label="上传者" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="上传时间" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="viewFile(scope.row)" >预览</el-button>
            <el-button type="text" @click.stop="quoteFile(scope.row)" >引用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="totalCsFile > 10"  style="margin-top:5px" class="pagination">
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="totalCsFile"
            :current-page="pageNumberCsFile"
            @current-change="currentChangeCsFile"
        />
      </div>
      <div style="margin-left: 10px">
        <p style="color: dimgrey;float: left" >共{{totalCsFile}}条</p>
      </div>
    </el-drawer>

    <!-- 新增话题类型对话框 addTypeDialog -->
    <el-dialog title="新增类型" :visible.sync="addTypeDialog" width="25%">
      <el-form :model="addTypeForm">
        <el-form-item label="名称" label-width="120px" required>
          <el-input v-model="addTypeForm.categoryName" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addTypeDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="addForumCategory()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑话题类型对话框editTypeDialog -->
    <el-dialog title="编辑类型" :visible.sync="editTypeDialog" width="25%">
      <el-form :model="editTypeForm">
        <el-form-item label="名称" label-width="80px" required>
          <el-input v-model="editTypeForm.categoryName" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editTypeDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="updateForumCategory()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 新增群组对话框addultrasonicGroupsDialog -->
    <el-dialog
      title="创建圈子/群组"
      :visible.sync="addUltrasonicGroupsDialog"
      width="35%"
    >
      <el-form :model="addUltrasonicGroupsForm">
        <el-form-item label="名称" label-width="140px">
          <el-input v-model="addUltrasonicGroupsForm.groupName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="简介" label-width="140px">
          <el-input
            v-model="addUltrasonicGroupsForm.groupProfile"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
          <el-form-item label="是否公开" label-width="140px">
              <el-select v-model="addUltrasonicGroupsForm.groupType" style="width: 100%">
                  <el-option label="公开圈子" value=0 />
                  <el-option label="私密圈子" value=1 />
              </el-select>
          </el-form-item>
          <el-form-item label="入圈需要验证" label-width="140px">
              <el-select v-model="addUltrasonicGroupsForm.isNeedVerify" style="width: 100%">
                  <el-option label="需要" value=true />
                  <el-option label="不需要" value=false />
              </el-select>
          </el-form-item>
          <el-form-item label="入圈验证码" label-width="140px">
            <el-input v-model="addUltrasonicGroupsForm.invitationCode" maxlength="6" autocomplete="off" />
          </el-form-item>
          <el-form-item label="圈外用户权限" label-width="140px">
              <el-select v-model="addUltrasonicGroupsForm.accessAuthority" style="width: 100%">
                  <el-option label="不能进入" value=0 />
                  <el-option label="可以进入但不能发言" value=1 />
                  <el-option label="可以进入且可以发言" value=2 />
              </el-select>
          </el-form-item>
          <el-form-item v-if="userDataTypeOptions.length > 0" label="所属领域" label-width="140px">
            <el-select
                    v-model="addUltrasonicGroupsForm.userDataType"
                    style="width: 100%"
            >
              <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签" label-width="140px">
              <el-select v-model="addUltrasonicGroupsForm.tagIdList" multiple collapse-tags filterable reserve-keyword style="width: 100%">
                <el-option v-for="item in tableData4"
                           :key="item.forumGroupTagId"
                           :label="item.tagName"
                           :value="item.forumGroupTagId">
                </el-option>
              </el-select>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addUltrasonicGroupsDialog = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="addGroup()"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 新增群标签对话框addTags -->
    <el-dialog title="添加群组标签" :visible.sync="addTagsDialog" width="25%">
      <el-form :model="addTagsForm">
        <el-form-item label="标签名称" label-width="100px">
          <el-input v-model="addTagsForm.tagName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="系统默认标签" label-width="100px">
          <el-select v-model="addTagsForm.isSystemDefault" style="width: 100%">
            <el-option label="是" value=true />
            <el-option label="否" value=false />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addTagsDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="addTags">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!--  超人圈配置对话框  -->
    <el-dialog title="超人圈(上传)配置" :visible.sync = "showEditForumConfigDialog" width="25%">
      <el-form v-model="forumConfig">
        <el-form-item label="允许上传附件大小（单位：M）"><br>
          <el-input-number v-model="forumConfig.maxForumAccessorySize"></el-input-number>
        </el-form-item>
        <el-form-item label="允许上传视频最大时长（单位：秒）"><br>
          <el-input-number v-model="forumConfig.maxForumVideoTimeLimit"></el-input-number>
        </el-form-item>
        <el-form-item label="视频观看心跳间隔（单位：秒）"><br>
          <el-input-number v-model="forumConfig.videoWatchHeartDuration"></el-input-number>
        </el-form-item>
        <span>提醒：以上配置只应用于APP端文件上传</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showEditForumConfigDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="editForumConfig()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="我的云盘" :visible.sync = "showNetDiskFileDialog" width="50%">
      <Net-Disk ref="myNetDisk"></Net-Disk>
      <el-button type="primary" @click="quoteNetDiskFile()" size="small" style="margin-left: 30px;">引用文件</el-button>
    </el-dialog>
    <el-drawer
        :title="addUltrasonicForm.customTitle"
        :visible.sync="previewArticleDialog"
        direction="ltr"
        width="30%"
    >
      <div v-html="htmlSrcFrame"></div>
    </el-drawer>
    <!--对话框：浏览PDF文件-->
    <el-dialog
        :visible="showPdf === true"
        :append-to-body='true'
        :modal-append-to-body='true'
        :lock-scroll='true'
        :destroy-on-close='true'
        :close-on-click-modal='false'
        width='80%'
        style="z-index: 111"
        :before-close="closePreviewClick"
        top="200px"
        center>
      <div v-if="showPdf === true" class="dialog-body-content-base-style"
           style="justify-content: center; align-items: center">
        <embed :src="this.fileUrl" style="width: 100%; height: 700px"/>
      </div>
    </el-dialog>
    <!--对话框：浏览 视频/图片/音频/文档-->
    <el-dialog
        :append-to-body="true"
        :visible="showDoc === true   || showImg === true || showVideo === true || showMp3 === true"
        :show-close='true'
        width="600"
        style="margin-top: 10px;z-index: 111"
        class="dialog-div-pre-style"
        :before-close="closePreviewClick"
        center>
      <div v-if="showDoc === true" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <iframe frameborder="0"
                :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl"
                width='100%'>
        </iframe>
      </div>
      <div align="center" v-else-if="showImg === true">
        <img :src="this.fileUrl" @load="onLoadImg" :height="boxHeight" :width="boxWidth"/>
      </div>
      <div v-else-if="showVideo === true" align="center" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <video :src="this.fileUrl" controls autoplay class="video" height="350"></video>
      </div>
      <div v-else-if="showMp3 === true" align="center" class="dialog-body-content-base-style">
        <audio :src="this.fileUrl" autoplay="autoplay" controls="controls" ref="audio" style="width: 70%"></audio>
      </div>
      <div align="center" style="margin-top: 10px;font-weight: bold">{{this.filePlayName}}</div>
    </el-dialog>
  </div>
</template>

<script>
import storage from "good-storage";
import { USER_KEY } from "@/assets/constant";
import {
  getAllForumsList,
  addForums,
  deleteOrBackForums,
  setForums,
  getForumCategoryList,
  addForumCategory,
  updateForumCategory,
  deleteOrBackForumCategory,
  getAllForumGroupList,
  addForumGroup,
  deleteOrBackForumGroup,
  updateForumGroup,
  getForumGroupTaps,
  addTag,
  deleteOrBackForumTag,
  updateForumConfig, getForumConfig, addForumFile
} from "@/api/ultrasonic";
import {
  addForumAccessory
} from '@/api/ultrasonicDetail'
import {
  getOSSUploadInfo,
} from "@/api/system/CSDocument/file";
import {
    getCloudUrl
} from "@/utils/urlutil"
import defaultImage from "/src/assets/images/grouplogo.png";
import {deepClone} from "@/utils";
import {getUserType} from "@/utils/userutil";
import {
  isVaild
} from "@/utils/validate";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
import {handleRes} from "@/utils/handleRes";
import MyEditor from "@/components/MyEditor/MyEditor.vue"
import {go2UltrasonicDetail} from "@/utils/UIHelper";
import {getAllUserList} from '@/api/userManagement'
import {
  getAllCSDocumentList
} from "@/api/system/CSDocument/file";
import NetDisk from "@/views/systemManagement/netDisk/user/index.vue"

export default {
  components:{
    MyEditor, //引入编辑器组件
    NetDisk
  },
  data() {
    return {
      navigationKey:"ultrasonic",
      userDataTypeOptions:[],
      imageGroupUrl: defaultImage,
      activeIndex: "0", // 当前索引
      loading: false, // 加载开关
      searchValue: "", // 搜索内容
      searchPosition:null, //帖子位置
      searchUserDataType:2,//数据类型
      searchForumType:null,//帖子类型
      searchForumType1:null,//帖子分类 ：普通超人圈、文章、小视频...
      searchUserList:[],//搜索用户列表
      searchUserLoading: false, //搜索用户加载符号
      userDataType:null, //领域
      pageSizeOptions:[{fieldValue:10,showName:"10条/页"},{fieldValue:20,showName:"20条/页"},{fieldValue:50,showName:"50条/页"},{fieldValue:100,showName:"100条/页"}],
      totalCount: 0, // 列表总数
      pageSize: 20, // 单页条数
      currentPage: 1, // 当前页码
      disableNoticeObject:false,//禁止选择通知圈子对象
      // 超人圈
      allForumGroupList1:[], //所有超人圈群组
      allExistForumGroupList:[], //所有未被删除的超人圈群组
      allForumsList: [], // 超人圈列表
      addUltrasonicDialog: false, // 添加超人圈对话框开关
      addUltrasonicForm: {}, // 添加超人圈表单

      // 帖子类型
      forumCategoryList: [], // 帖子类型列表
      addTypeDialog: false, // 添加帖子类型对话框开关
      addTypeForm: {}, // 添加帖子类型表单
      editTypeDialog: false, // 编辑帖子类型对话框开关
      editTypeForm: {}, // 编辑帖子类型表单

      // 超人圈群组
      allForumGroupList: [], // 超人圈群组列表
      addUltrasonicGroupsDialog: false, // 添加超人圈群组对话框开关
      addUltrasonicGroupsForm: {tagIdList:[]}, // 添加超人圈群组表单

      // 圈子标签
      forumGroupTagList:[],// 圈子标签列表
      tableData4: [], // 圈子标签列表
      addTagsDialog: false, // 添加圈子标签对话框开关
      addTagsForm: {}, // 圈子标签表单

      categoryList:[],  //分类列表
      groupTypeList:[{id:0,showName:"私有"},{id:1,showName:"公开"}],
      groupType:null, //是否私密圈子
      userData:null,

      //超人圈配置，如附件大小、视频时长等
      showEditForumConfigDialog:false,
      forumConfig:{},

      //超人圈—图文混合文章
      addRichArticleDialog:false,//添加图文混合帖子对话框开关
      editor:null,//编辑器对象
      editorFileList:[],//编辑器文件
      editorAttachmentList:[],//编辑器附件
      previewArticleDialog:false, //是否显示 文章预览对话框
      htmlSrcFrame:"", //文章预览html
      showCsFileDialog: false,//打开插入csfile对话框
      csFileList: [],//csfile列表客服文档
      pageNumberCsFile:1,
      pageSizeCsFile:10,
      totalCsFile:0,
      //浏览文件配置参数
      showMp3:   false,
      showImg:   false,
      showDoc:   false,
      showPdf:   false,
      showVideo: false,
      fileUrl:    "",
      boxWidth: "",
      boxHeight:"",
      filePlayName:"",      //文件完整名称
      showNetDiskFileDialog: false,
    };
  },
  created() {
    this.userDataTypeOptions = getUserType()
    this.categoryList = getUserType()
    this.getUserData(); //获取登陆用户信息
    this.getAllForumGroupList();//获取超人圈群组列表
    this.getForumCategoryList(); //获取帖子类型列表（科属类型 ）
    this.getForumConfig();//超人圈配置信息
    this.getGroupTab(); //获取群组标签
    this.activeIndex="0" //默认标签页
    let navigationObj = getNavigationItemObj(this.navigationKey)
    if(this.activeIndex === navigationObj.activeIndex){
      if(this.activeIndex === '0'){
        this.searchValue = navigationObj.searchValue
        this.currentPage = navigationObj.currentPage
        this.searchPosition = navigationObj.searchPosition
        this.searchForumType = navigationObj.searchForumType
        this.searchForumType1 = navigationObj.searchForumType1
        this.pageSize = navigationObj.pageSize
      }else if (this.activeIndex === '2'){
        this.currentPage = navigationObj.currentPage
        this.userDataType = navigationObj.userDataType
        this.searchValue = navigationObj.searchValue
        this.groupType = navigationObj.groupType
        this.pageSize = navigationObj.pageSize
      }
    }
    if(isVaild(this.$route.params.part)){
      console.log(this.$route.params)
      this.activeIndex=this.$route.params.part.toString()
      this.allForumGroupList=[]
      let params=this.$route.params
      if(isVaild(params.searchValue)){
        this.searchValue=params.searchValue
      }
      if(2===this.$route.params.part){
        if(isVaild(params.groupType)){
          this.groupType=params.groupType
        }
        if(isVaild(params.userDataType)){
          this.userDataType=params.userDataType
        }
      }
      this.currentPage = params.currentPage;
    }
    this.refreshCurrentList()
  },

  methods: {
    /**
     * 获取超人圈全局配置参数
     */
    getForumConfig(){
      getForumConfig().then((res)=>{
        handleRes(res,()=>{
          this.forumConfig = res.data
        })
      })
    },
    /**
     * 打开新增标签类型对话框
     */
    openEditForumConfigDialog(){
      this.showEditForumConfigDialog = true;
    },
    editForumConfig(){
      let data = deepClone(this.forumConfig)
      updateForumConfig(data).then(res=>{
        handleRes(res,()=>{
          this.showEditForumConfigDialog = false;
          this.$message("修改成功")
        })
      });
    },
    /**
     * 是否显示默认群组头像
     */
    showDefaultImage(url){
      if(url===null||url===""){
        return true;
      }
      return false;
    },
    /**
     *获取登陆用户基础信息
     */
    getUserData() {
      this.userData = storage.get(USER_KEY);
    },
    /**
     * 页面大小变化响应事件
     */
    onPageSizeChange(e){
      this.pageSize=e;
      this.currentPage=1;
      this.refreshCurrentList();
    },
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      switch (this.$route.query.active) {
        case "0":
          this.getAllForumsList();
          break;
        case "1":
          this.getForumCategoryList();
          break;
        case "2":
          this.getForumGroupList();
          break;
        case "3":
          this.getForumTagList();
          break;
        default:
          this.getAllForumsList()
          break;
      }
    },
    addGroup(){
      this.addUltrasonicGroupsDialog = false;
      const temp={
        accessAuthority: this.addUltrasonicGroupsForm.accessAuthority,
        groupName:this.addUltrasonicGroupsForm.groupName,
        groupProfile:this.addUltrasonicGroupsForm.groupProfile,
        groupType:this.addUltrasonicGroupsForm.groupType,
        isNeedVerify:this.addUltrasonicGroupsForm.isNeedVerify,
        userDataType:this.addUltrasonicGroupsForm.userDataType,
        invitationCode:this.addUltrasonicGroupsForm.invitationCode,
      };
      if(this.addUltrasonicGroupsForm.tagIdList!==[]){
        temp.tagIdList=this.addUltrasonicGroupsForm.tagIdList;
      }
      addForumGroup(temp).then((res) => {
        this.refreshCurrentList();
      });

    },
    /**
     * 获取群组标签
     */
    getGroupTab(){
      var totalCount=0;
      const params={
        pageNumber:1,
        pageSize:0,
        where:[{"field":"isDeleted","value":"false","op":"equal"}]
      };
      getForumGroupTaps(params).then((res) => {
          if(res.data.rows!==[]){
            this.tableData4=[];
            console.log(res)
            const userData = storage.get(USER_KEY);
            for(const temp of res.data.rows){
              if(temp.createUserId===userData.UserID||temp.isSystemDefault===true){
                if(temp.isSystemDefault){
                  temp.tagName=temp.tagName+' (推荐)'
                }
                this.tableData4.push(temp)
              }
            }
          }
        });
    },
    /**
     * 切换 tab
     */
    handleClick() {
      this.currentPage = 1;
      this.searchValue = "";
      // this.refreshCurrentList();
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      this.refreshCurrentList();
    },
    /**
     * 重置
     */
    reset() {
      this.currentPage = 1;
      this.searchValue = "";
      this.refreshCurrentList();
    },
    /**
     * 翻页
     *
     * @param {number} el-uploadeeeecurrentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },
    /**
     * 获取所属领域名称
     */
    showCategory(userDataType){
      if(userDataType===null){
        return "-";
      }
      for(const temp of this.categoryList){
        if(temp.id===userDataType){
          return temp.name;
        }
      }
      return "-";
    },
    /**
     * 获取分类名称
     * @param row
     * @returns {*|string|default.methods.editTypeForm.categoryName|string}
     */
    getCategoryName(row){
      if(row.categoryId===0||row.categoryId===null){
        return '-';
      }
      for(const temp of this.forumCategoryList){
        if(temp.forumCategoryId===row.categoryId){
          return temp.categoryName;
        }
      }
      return row.forumCategory;
    },
    /**
     * 查找群组名称
     */
    getForumGroupName(id){
      if(id===0){
        return '-';
      }
      if(this.allForumGroupList1===[]){
        return '-';
      }
      for(const temp of this.allForumGroupList1){
        if(temp.forumGroupId===id){
          return temp.groupName;
        }
      }
      return '-';
    },
    /**
     * 获取OSS上传信息
     *
     * @param {object} file 文件对象
     */
    getOSSUploadInfo(file) {
      const params = {
        DataType: "8",
        ID: null, //ForumGroupID
      };

      getOSSUploadInfo(params).then((res) => {
        this.ossInfo = res.resultData.AssumeRoleToken;
        this.ossPath = res.resultData.PicSavePath;
        // this.uploadFile(file);
      });
    },
    /**
     * 获取所有帖子
     */
    getAllForumsList() {
      this.loading = true;
      this.allForumsList=[];
      const params = {
        userDataType: this.searchUserDataType,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        // type:this.searchPosition,
        keyWord: this.searchValue,
      };
      if(this.searchForumType!==null&&this.searchForumType!=""){
        params.where=[]
        params.where.push({"field":"categoryId","value":this.searchForumType.toString(),"op":"equal"})
      }
      if(this.searchForumType1!==null&&this.searchForumType1!==undefined&&this.searchForumType1!==""){
        if(params.where===undefined){
          params.where=[]
        }
        params.where.push({"field":"forumType","value":this.searchForumType1.toString(),"op":"equal"})
      }
      if(null !== this.searchPosition && this.searchPosition!==0 && ''!==this.searchPosition){
        if(params.where===undefined){
          params.where=[]
        }
        if(this.searchPosition===1){
          params.where.push({"field":"isHideOnSquare","value":"false","op":"equal"})
        }
        else{
          params.where.push({"field":"isHideOnSquare","value":"true","op":"equal"})
        }
      }
      setNavigationItemWithObj(this.navigationKey,{
        activeIndex:this.$route.query.active || "0",
        searchUserDataType:this.searchUserDataType,
        currentPage:this.currentPage,
        searchPosition:this.searchPosition,
        searchValue:this.searchValue,
        searchForumType1:this.searchForumType1,
        searchForumType:this.searchForumType,
        userDataType:this.userDataType,
        pageSize:this.pageSize
      })
      getAllForumsList(params).then((res) => {
        this.allForumsList = res.data.rows;
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 获取所有帖子类型
     */
    getForumCategoryList() {
      this.loading = true;
      const params = {
        sortName:'createTime',
        sortOrder:'desc'
      };
      getForumCategoryList(params).then((res) => {
        this.forumCategoryList = res.data;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 设置帖子状态
     *
     * @param {object} row 所选对象信息
     * @param {number} type 所选状态类型
     */
    setForums(row, type) {
      const data = {
        forumId: row.forumId,
        categoryId:row.categoryId,
        customTitle:row.customTitle
      };
      if(type===0){
        data.isEssential=row.isEssential !== false
      }
      else if(type===1){
        data.isTop=row.isTop!== false
      }
      else if (type===2){
        data.isRecommended=row.isRecommended!== false
      }
      setForums(data).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.refreshCurrentList();
      });
    },
    /**
     * 打开新增帖子对话框
     */
    openAddUltrasonicDialog() {
      this.addUltrasonicForm = {};
      this.addUltrasonicForm.isHideOnSquare = false;
      this.addUltrasonicForm.needNotice=0; //不需要通知阅读
      this.addUltrasonicForm.forumType = 0;
      this.addUltrasonicForm.source = 0
      this.addUltrasonicForm.resourceType = 0;
      this.addUltrasonicForm.userDataType = 0;
      // this.addUltrasonicForm.source = 0;
      this.getForumCategoryList();
      this.addUltrasonicDialog = true;
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    /**
     * 预 览 文 章
     */
    previewArticle(){
      let head='<!DOCTYPE html>  <html lang="zh">  <head>  <meta charset="UTF-8">  <meta name="viewport" content="width=device-width, initial-scale=1.0">  <title>文章 - 超人圈 - 麦粒智检 - SIUI汕头超声</title>  <style>  body {   margin: 0;  font-family: Arial, sans-serif;  }  .container {   max-width: 800px;  margin: 0 auto;   padding: 20px;  }  .content {  display: flex;   flex-direction: column; } .content img, .content video {   width: 100%;  height: auto;   }  @media (max-width: 600px) {  .container {  padding: 10px;  }  }  </style>  </head>  <body><div class="container"><div class="content">'
      let tail='</div></div></body></html>'
      let editorHtml=this.$refs.myEditor.editor.getHtml()
      console.log(editorHtml)
      if(editorHtml!=='<p><br></p>'){
        this.htmlSrcFrame=head+editorHtml+tail
        this.previewArticleDialog=true
      }
      else{
        this.$message({
          message: "文章没有任何内容！",
          type: "warning",
        });
      }
    },
    /**
     * 新增帖子 type=0普通话题 type=1文章
     */
    addUltrasonic(type) {
      //参数判断
      if (this.addUltrasonicForm.isHideOnSquare === true && null == this.addUltrasonicForm.forumGroupId) {
        this.$message({
          message: "发帖前请选择一个圈子！",
          type: "warning",
        });
        return;
      }
      if (null === this.addUltrasonicForm.categoryId || undefined === this.addUltrasonicForm.categoryId || '' === this.addUltrasonicForm.categoryId) {
        this.$message({
          message: "请设置帖子类型！",
          type: "warning",
        });
        return;
      }
      if (null === this.addUltrasonicForm.customTitle || undefined === this.addUltrasonicForm.customTitle || '' === this.addUltrasonicForm.customTitle || 4 > this.addUltrasonicForm.customTitle.length) {
        this.$message({
          message: "请完善标题，要求不少于4个字！",
          type: "warning",
        });
        return;
      }
      if(1===this.addUltrasonicForm.needNotice && ( null === this.addUltrasonicForm.idList || this.addUltrasonicForm.idList===undefined || this.addUltrasonicForm.idList.length===0)){
        this.$message({
          message: "请完善通知圈子或通知用户！",
          type: "warning",
        });
        return;
      }
      if (type === 0) {
        //新增普通帖子
        // printObj(data)
        if (this.addUltrasonicForm.customDescription.length === 0) {
          this.$message({
            message: "帖子内容不能为空！",
            type: "warning",
          });
          return;
        }
        if(this.addUltrasonicForm.forumType===1){
          if(undefined===this.addUltrasonicForm.postURL||null===this.addUltrasonicForm.postURL||""===this.addUltrasonicForm.postURL){
              this.$message({
                message: "链接不能为空！",
                type: "warning",
              });
              return;
          }
        }
        else if(this.addUltrasonicForm.forumType===2){
          if(this.addUltrasonicForm.resourceID===undefined||this.addUltrasonicForm.resourceID===null||this.addUltrasonicForm.resourceID===""){
            this.$message({
              message: "视频ID不能为空！",
              type: "warning",
            });
            return;
          }
        }
      } else {
        //新增文章
        this.editor = this.$refs.myEditor.editor;
        this.addUltrasonicForm.htmlJson = this.editor.getHtml();
        this.addUltrasonicForm.customDescription = this.editor.getText();
        if (this.addUltrasonicForm.htmlJson.length === 0) {
          this.$message({
            message: "帖子内容不能为空！",
            type: "warning",
          });
          return;
        }
      }
      //构造请求参数
      const data = deepClone(this.addUltrasonicForm)
      //调用接口
      addForums(data).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "发帖成功！",
          });
          let addArticleId = res.data
          if (type === 1 && addArticleId !== null) {
            this.processArticlePicAndVideoFiles(addArticleId)
            this.processQuoteCsFiles(addArticleId)
          }
        }
        if (type === 0) {
          this.addUltrasonicDialog = false;
        } else {
          this.addRichArticleDialog = false;
        }
        this.refreshCurrentList();
      });
    },

    /**
     * 处理新增文章场景下的引用客服文档文件
     * @param addArticleId
     */ async processQuoteCsFiles(addArticleId) {
      // 绑定帖子客服文档 与帖子id的关系
      this.editorAttachmentList = this.$refs.myEditor.quoteCsFileList;
      let existAttachmentPath = this.editor.getElemsByType('attachment').concat(this.editor.getElemsByType('image')).concat(this.editor.getElemsByType('video')) //文章中的图片列表 //文章中的图片列表
      console.log(existAttachmentPath)
      if (existAttachmentPath.length !== 0) {
        if (this.editorAttachmentList.length > 0) {
          for (let i = 0; i < this.editorAttachmentList.length; i++) {
            for (let j = 0; j < existAttachmentPath.length; j++) {
              let tempUrl=''
              if(existAttachmentPath[j].type==='attachment'){
                tempUrl=existAttachmentPath[j].link
              }
              else{
                tempUrl=existAttachmentPath[j].src
              }
              if (tempUrl === this.editorAttachmentList[i].fileUrl) {
                //构造传参 fileUrl,videoCover,uploadFileSize,fileType
                let csFileID = this.editorAttachmentList[i].csFileID
                let fileUrl = this.editorAttachmentList[i].fileUrl
                if (fileUrl.indexOf('/UploadFiles') > -1) {
                  fileUrl = fileUrl.substring(fileUrl.indexOf('/UploadFiles'))
                }
                let uploadFileSize = this.editorAttachmentList[i].size //文件大小
                let param = {
                  accessoryName: this.editorAttachmentList[i].name,
                  fileName: this.editorAttachmentList[i].name,
                  fileSuffix: '.' + this.editorAttachmentList[i].type,
                  fileSize: uploadFileSize,
                  forumId: addArticleId,
                  downUrl: fileUrl,
                  resourceType: 1,
                  resourceId: csFileID
                }
                await addForumAccessory(param)
                break;
              }
            }
          }
        }
      }
    },
    /**
     * 处理新增文章场景下的新增文件
     * @param type
     * @param addArticleId
     */ async processArticlePicAndVideoFiles(addArticleId) {
      // 绑定图片、视频和帖子id的关系
      let existFilePath = [] //文章中的文件列表
      let existPicList = this.editor.getElemsByType('image') //文章中的图片列表
      if (existPicList !== null && existPicList.length > 0) {
        for (let i = 0; i < existPicList.length; i++) {
          existFilePath.push(existPicList[i])
        }
      }
      let existVideoList = this.editor.getElemsByType('video') //文章中的视频列表
      if (existVideoList !== null && existVideoList.length > 0) {
        for (let j = 0; j < existVideoList.length; j++) {
          existFilePath.push(existVideoList[j])
        }
      }
      this.editorFileList = this.$refs.myEditor.fileInfoList;
      if (existFilePath.length !== 0) {
        if (this.editorFileList.length > 0) {
          for (let i = 0; i < this.editorFileList.length; i++) {
            for (let j = 0; j < existFilePath.length; j++) {
              if (existFilePath[j].src === this.editorFileList[i].fileUrl) {
                //构造传参 fileUrl,videoCover,uploadFileSize,fileType
                let fileUrl = this.editorFileList[i].fileUrl
                if (fileUrl.indexOf('/UploadFiles') > -1) {
                  fileUrl = fileUrl.substring(fileUrl.indexOf('/UploadFiles'))
                }
                let videoCover = this.editorFileList[i].cover
                if (undefined !== videoCover && null !== videoCover) {
                  //封面url
                  if (videoCover.indexOf('/UploadFiles') > -1) {
                    videoCover = videoCover.substring(videoCover.indexOf('/UploadFiles'))
                  }
                }
                let uploadFileSize = this.editorFileList[i].size //文件大小
                let fileType = this.editorFileList[i].type.indexOf('image') > -1 ? 0 : (this.editorFileList[i].type.indexOf('video') > -1 ? 1 : null)

                if (null !== fileType) {
                  this.addForumFile("/" + fileUrl, addArticleId, fileType, uploadFileSize, videoCover);
                }
                break;
              }
            }
          }
        }
      }
      // 绑定帖子文件 与帖子id的关系
      this.editorAttachmentList = this.$refs.myEditor.uploadAccessoryFileList;
      let existAttachmentPath = this.editor.getElemsByType('attachment') //文章中的附件列表
      console.log(existAttachmentPath)
      if (existAttachmentPath.length !== 0) {
        if (this.editorAttachmentList.length > 0) {
          for (let i = 0; i < this.editorAttachmentList.length; i++) {
            for (let j = 0; j < existAttachmentPath.length; j++) {
              if (existAttachmentPath[j].fileName === this.editorAttachmentList[i].name) {
                console.log("bingo",existAttachmentPath[j].link,this.editorAttachmentList[i].fileUrl)
                //构造传参 fileUrl,videoCover,uploadFileSize,fileType
                let fileUrl = this.editorAttachmentList[i].fileUrl
                if (fileUrl.indexOf('/UploadFiles') > -1) {
                  fileUrl = fileUrl.substring(fileUrl.indexOf('/UploadFiles'))
                }
                let uploadFileSize = this.editorAttachmentList[i].size //文件大小
                let param = {
                  accessoryName: this.editorAttachmentList[i].name,
                  fileName: this.editorAttachmentList[i].name,
                  fileSuffix: '.' + this.editorAttachmentList[i].type,
                  fileSize: uploadFileSize,
                  forumId: addArticleId,
                  downUrl: fileUrl,
                  resourceType:0,
                  resourceId:null
                }
                await addForumAccessory(param)
                break;
              }
            }
          }
        }
      }

    },
    /**
     * 新增超人圈帖子文件
     * @param fileUrl
     * @param forumId
     * @param fileType
     * @param fileSize
     * @param videoCover
     */
    addForumFile(fileUrl,forumId,fileType,fileSize,videoCover){
      const params={
        fileUrl:fileUrl,
        forumId:forumId,
        fileType:fileType,
        fileSize:fileSize,
        faceUrl:videoCover
      };
      addForumFile(params).then(() => {
        this.getForumFileList();
      });
    },
    /**
     * 删除/恢复帖子
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackForums(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.isDeleted) {
        tips1 = "是否恢复该帖子";
        tips2 = "恢复成功";
      } else {
        tips1 = "是否删除该帖子";
        tips2 = "删除成功";
      }
      const params = {
        forumId: row.forumId,
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          deleteOrBackForums(params).then(() => {
            this.$message({
              type: "success",
              message: tips2,
            });
            this.refreshCurrentList();
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
    /**
     * 跳转到帖子详情
     *
     * @param {object} row 所选对象信息
     */
    goToUltrasonicDetail(row) {
      go2UltrasonicDetail(this,row.forumId)
    },
    /**
     * 打开新增帖子类型对话框
     */
    openAddTypeDialog() {
      this.addTypeDialog = true;
      this.addTypeForm = {}
      this.addTypeForm.userDataType = 0;
    },
    /**
     * 打开新增标签类型对话框
     */
    openAddTagDialog(){
      this.addTagsDialog = true;
    },
    /**
     * 新增帖子类型
     */
    addForumCategory() {
      this.addTypeDialog = false;
      const data = deepClone(this.addTypeForm)
      addForumCategory(data).then(() => {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.refreshCurrentList();
      });
    },
    /**
     * 打开编辑帖子类型对话框
     *
     * @param {object} row 所选对象信息
     */
    openEditTypeDialog(row) {
      this.$set(this.editTypeForm, "forumCategoryId", row.forumCategoryId);
      this.$set(this.editTypeForm, "categoryName", row.categoryName);
      this.editTypeDialog = true;
    },
    /**
     * 修改帖子类型
     */
    updateForumCategory() {
      this.editTypeDialog = false;
      const data = {
        forumCategoryId: this.editTypeForm.forumCategoryId,
        categoryName: this.editTypeForm.categoryName
      };
      updateForumCategory(data).then(() => {
        this.$message({
          message: "修改成功",
          type: "success",
        });
        this.refreshCurrentList();
      });
    },
    /**
     * 删除/恢复帖子类型
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackForumCategory(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.IsDeleted) {
        tips1 = "是否恢复该帖子类型";
        tips2 = "恢复成功";
      } else {
        tips1 = "是否删除该帖子类型";
        tips2 = "删除成功";
      }

      const params = {
        forumCategoryId: row.forumCategoryId,
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          deleteOrBackForumCategory(params).then(() => {
            this.$message({
              type: "success",
              message: tips2,
            });
            this.refreshCurrentList();
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
    /**
     * 获取所有超人圈群组
     */
    getAllForumGroupList() {
      getAllForumGroupList({
        pageNo: 1
      }).then((res) => {
        return res.data.total
      }).then((res) => {
        return getAllForumGroupList({
          pageSize: res
        })
      }).then((res) => {
        this.allForumGroupList1 = res.data.rows.map((e) => {
          return {
            forumGroupId: e.forumGroupId,
            groupName: e.groupName,
          };
        });
        if(res.data.rows.length>0){
          for(let i=0;i<res.data.rows.length;i++){
            if(res.data.rows[i].isDeleted===false){
              this.allExistForumGroupList.push(res.data.rows[i])
            }
          }
        }
      })
    },
    /**
     * 获取超人圈群组
     */
    getForumGroupList() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      if(this.userDataType!==null){
        params.userDataType=this.userDataType;
      }
      if(this.searchValue!==""){
        params.keyWord=this.searchValue;
      }
      if(isVaild(this.groupType)){
        params.where=[];
        params.where.push({"field":"groupType","value":this.groupType.toString(),"op":"equal"});
      }
      setNavigationItemWithObj(this.navigationKey,{
        activeIndex:this.$route.query.active || "0",
        currentPage:this.currentPage,
        userDataType:this.userDataType,
        searchValue:this.searchValue,
        groupType:this.groupType,
        pageSize:this.pageSize
      })
      getAllForumGroupList(params).then((res) => {
        this.allForumGroupList = res.data.rows;
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 打开添加群组对话框
     */
    openAddUltrasonicGroupsDialog() {
      this.addUltrasonicGroupsDialog = true;
    },
    /**
     * 推荐/取消推荐单个超人圈群组状态
     *
     * @param {object} row 所选对象信息
     */
    setForumGroup(row) {
      console.log(row.showType);
      const params = {
          forumGroupId: row.forumGroupId,
          showType:row.showType === 0?0:1
      };
        updateForumGroup(params).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.refreshCurrentList();
      });
    },
    /**
     * 删除/恢复单个超人圈群组
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackForumGroup(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.isDeleted) {
        tips1 = "是否恢复该超人圈群组";
        tips2 = "恢复成功";
      } else {
        tips1 = "是否删除该超人圈群组";
        tips2 = "删除成功";
      }
      const params = {
        forumGroupId: row.forumGroupId,
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          deleteOrBackForumGroup(params).then(() => {
            this.$message({
              type: "success",
              message: tips2,
            });
            this.refreshCurrentList();
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
    /**
     *  跳转超人圈群组详情
     */
    goToUltrasonicGroupsDetail(row) {
      let judgeCreator=false;
      if(row.createUserId===this.userData.UserID){
        judgeCreator=true;
      }
      this.$router.push({
        path: "ultrasonicGroupsDetail",
        query: {
          ForumGroupID: row.forumGroupId,
          part:2,//标签页号
          judgeCreator:judgeCreator,
          groupType:this.groupType,
          userDataType:this.userDataType,
          searchValue:this.searchValue,
          currentPage:this.currentPage
        },
      });
    },
    /**
     *  跳转超人圈群组成员列表
     */
    goToUltrasonicGroupsMember(row) {
      this.$router.push({
        name: "ultrasonicGroupsMember",
        query: {
          ForumGroupID: row.forumGroupId,
          groupName:row.groupName,
          part:2,//标签页号
          groupType:this.groupType,
          userDataType:this.userDataType,
          searchValue:this.searchValue,
          currentPage:this.currentPage
        },
      });
    },
    /**
     * 跳转到超声群帖子页面
     */
    goToUltrasonicGroupsPost(row) {
      this.$router.push({
        name: "ultrasonicGroupsPost",
        query: {
          ForumGroupID: row.forumGroupId,
          groupName:row.groupName,
          part:2,//标签页号
          groupType:this.groupType,
          userDataType:this.userDataType,
          searchValue:this.searchValue,
          currentPage:this.currentPage
        },
      });
    },
    /**
     *  删除超人圈群组
     */
    deleteUltrasonicGroups(index, row) {
      this.$confirm("是否删除该超人圈群组", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
    getForumTagList(){
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      getForumGroupTaps(params).then((res) => {
        this.forumGroupTagList = res.data.rows;
        this.totalCount=res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 添加标签
     */
    addTags() {
     const params={
       isSystemDefault:this.addTagsForm.isSystemDefault===null?false:this.addTagsForm.isSystemDefault,
       tagName:this.addTagsForm.tagName
     };
     addTag(params).then((res) => {
         if(res.code===200) {
           this.$notify({
             title: '添加成功',
             type: 'success'
           });
         }
         this.refreshCurrentList();
         this.addTagsDialog=false;
      });
    },
    /**
     *  删除标签
     */
    deleteTags(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.isDeleted) {
        tips1 = "是否恢复该标签";
        tips2 = "恢复成功";
      } else {
        tips1 = "是否删除该标签";
        tips2 = "删除成功";
      }
      const params = {
        forumGroupTagId: row.forumGroupTagId
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
      .then(() => {
        deleteOrBackForumTag(params).then(() => {
          this.$message({
            type: "success",
            message: tips2,
          });
          this.refreshCurrentList();
        });
      })
      .catch(() => {
        this.$message("取消操作");
      });
    },
    /**
     * 打开创建文章对话框（两种模式）
     */
    handleCommandCreateArticle(command){
      if("richEditor"==command){
        //发表图文混合帖子
        this.addRichArticleDialog=true //开启文章编辑器对话框
        this.addUltrasonicForm = {};
        this.addUltrasonicForm.isHideOnSquare=false //是否只显示在圈内
        this.addUltrasonicForm.needNotice=0 //不需要通知阅读
        this.addUltrasonicForm.forumType = 6;//帖子类型：图文混合编排
        this.addUltrasonicForm.resourceType = 0;//资料类型
        this.addUltrasonicForm.source = 0;//帖子来源：0-SIUI分享 1-用户反馈案列
        if(this.editor){
          this.editor.clear()
        }
      } else if ("normalEditor" == command) {
        //发表普通帖子
        this.openAddUltrasonicDialog()
      }
    },
    /**
     * 提取字符串前100个字
     * @param str
     * @returns {*|string}
     */
    extractFirst100Chars(str,num) {
      if(str===null||str===undefined||str==""){
        return '无';
      }
      else if (str.length <= num) {
        return str;
      } else {
        return str.substring(0, num) + "...";
      }
    },
    /**
     * 新建帖子时候，通知对象修改
     */
    processChangeNoticeObject() {
      this.$forceUpdate()
      this.addUltrasonicForm.idList = []
      if (1 === this.addUltrasonicForm.noticeObject) {
        if (true === this.addUltrasonicForm.isHideOnSquare) {
          this.disableNoticeObject = true
          if (this.addUltrasonicForm.forumGroupId !== null && this.addUltrasonicForm.forumGroupId !== undefined) {
            this.addUltrasonicForm.idList = [this.addUltrasonicForm.forumGroupId]
          }
        } else {
          this.disableNoticeObject = false
        }
      }
    },
    /**
     * 选择一个圈子来发布帖子
     */
    selectForumGroup() {
      this.$forceUpdate()
      if (true === this.addUltrasonicForm.isHideOnSquare){
        this.disableNoticeObject=true
        if(1 === this.addUltrasonicForm.needNotice && 1 === this.addUltrasonicForm.noticeObject){
          if(this.addUltrasonicForm.forumGroupId!==null && this.addUltrasonicForm.forumGroupId!==undefined){
            this.addUltrasonicForm.idList = [this.addUltrasonicForm.forumGroupId]
          }
        }
      }
      else{
        this.disableNoticeObject=false
      }
    },
    /**
     * 选择用户列表
     */
    remoteSearchUserList(query){
      if (query !== '') {
        this.searchUserLoading = true;
        setTimeout(() => {
          this.searchUserLoading = false;
          this.searchUserList = []
          getAllUserList({
            sortName: "",
            sortOrder: "",
            pageNumber: 1,
            pageSize: 30,
            keyWord: query,
          }).then((res) => {
            this.searchUserList=res.data.rows;
          });
        }, 200);
      } else {
        this.searchUserList = [];
      }
    },
    /**
     * 获取用户详细信息
     */
    getUserDetailInfo(item){
      return  item.nickname+ '  手机:'+((item.mobilePhone===null||item.mobilePhone==='')?'无':item.mobilePhone)+ '  邮箱:'+((item.loginEmail  ===null||item.loginEmail  ==='')?'无':item.loginEmail)
    },

    /**
     * 打开插入客服文档对话框
     */
    showInsertCsFileDialog() {
      this.showCsFileDialog = true
      this.getCSDocumentList()
    },
    /**
     * 打开插入云盘文件对话框
     */
    showInsertNetDiskFileDialog(){
      // this.$refs.myNetDisk.getUserDirectoryList(this.userData.UserID)
      this.showNetDiskFileDialog = true
    },
    /**
     * 引用选择的文件
     */
    quoteNetDiskFile(){
      let quoteFile=this.$refs.myNetDisk.currentRow
      if (quoteFile === null) {
        this.$message('请选择一个想要引用到文章的文件！');
      } else if (quoteFile.directoryType === true) {
        this.$message('系统不支持引用目录，请选择其他文件！');
      } else {
        console.log(quoteFile)
      }
    },
    currentChangeCsFile(currentPage){
      this.pageNumber = currentPage;
      this.getCSDocumentList()
    },
    getCSDocumentList(){
      this.csFileList = []
      return new Promise((resolve, reject) => {
        const param = {
          pageNumber: this.pageNumberCsFile,
          pageSize: this.pageSizeCsFile,
          type: 0
        };
        getAllCSDocumentList(param).then((res) => {
          if (res.code === 200) {
            this.csFileList = res.data.rows
            this.totalCsFile = res.data.total
          }
        });
      });
    },
    // 引用客服文档
    quoteFile(row) {
      this.$refs.myEditor.quoteFile(row)
    },
    //查看文件
    viewFile(row) {
      this.filePlayName=row.fileName+row.fileSuffix;
      let type = this.iconByType(row);
      this.fileUrl = this.config.RESOURCES+row.downUrl;
      if (type.indexOf("doc") !== -1 || type.indexOf("docx") !== -1 || type.indexOf("xls") !== -1 || type.indexOf("xlsx") !== -1) {
        this.showDoc = true;
      }
      else if (type.indexOf("pdf") !== -1) {
        this.showPdf = true;
      }
      else if (type.indexOf("jpg") !== -1 || type.indexOf("png") !== -1 || type.indexOf("jpeg") !== -1) {
        this.showImg=true;
      }
      else if (type.indexOf("avi") !== -1 || type.indexOf("mp4") !== -1 || type.indexOf("webm") !== -1 || type.indexOf("m4v") !== -1 || type.indexOf("rmvb") !== -1 || type.indexOf("mpg") !== -1 || type.indexOf("3gp") !== -1 || type.indexOf("swf") !== -1 || type.indexOf("mkv") !== -1) {
        this.showVideo = true;
      }
      else if (type.indexOf("mp3")!== -1){
        this.showMp3 = true;
      }
      else {
        this.$message("当前文件暂不支持预览")
      }
    },
    // 预览图片时调整图片预览大小
    onLoadImg: function (e) {
      const imgURL = this.fileUrl;
      const res = new Image();
      res.src = imgURL;
      if (res.naturalHeight / res.naturalWidth > 1) {
        this.boxHeight = 500 + 'px';
        this.boxWidth = Math.floor(500 * res.naturalWidth / res.naturalHeight) + 'px';
      } else if (res.naturalHeight / res.naturalWidth === 1) {
        if (res.naturalHeight > 500) {
          this.boxHeight = 500 + 'px';
          this.boxWidth = 500 + 'px';
        } else {
          this.boxWidth = res.naturalWidth + 'px';
          this.boxHeight = res.naturalHeight + 'px';
        }
      } else if (res.naturalWidth / res.naturalHeight > 1) {
        this.boxWidth = 650 + 'px';
        this.boxHeight = Math.floor(650 * res.naturalHeight / res.naturalWidth) + 'px';
      }
      this.$forceUpdate();
    },

    //关闭预览文件对话框
    closePreviewClick() {
      if (this.showDoc === true) {
        this.showDoc = false;
      } else if (this.showPdf === true) {
        this.showPdf = false;
      } else if (this.showVideo === true) {
        this.showVideo = false;
      } else if (this.showImg === true) {
        this.showImg = false;
      } else if (this.showMp3 === true) {
        this.showMp3 = false;
      }
    },
    /**
     * 经过文件后缀返回文件的图标
     */
    iconByType(row) {
      return row.fileSuffix.substring(row.fileSuffix.lastIndexOf(".") + 1, row.fileSuffix.length)
    },
  },
};
</script>

<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}

</style>
